<template>
	<div>
		<o-section>
			<o-password
				v-model="setup.password"
				:label="$t('common.global.password')"
				autofocus
				required
				@keydown.enter.stop="setup.validateAsync()"/>
		</o-section>
		<o-section align="right">
			<o-button
				outline
				color="danger"
				@click="setup.cancel()">
				{{ $t('common.actions.cancel') }}
			</o-button>
			<o-button
				color="info"
				@click="setup.validateAsync()">
				{{ $t('common.actions.validate') }}
			</o-button>
		</o-section>
	</div>
</template>

<script setup lang="ts">
import { inject } from 'vue';

const _modal = inject<OrionModal>('_modal');
// #region Setup
import type { ModalConfirmPasswordEmits, ModalConfirmPasswordProps } from './ModalConfirmPasswordSetup';
import ModalConfirmPasswordSetup from './ModalConfirmPasswordSetup';
const emits = defineEmits<ModalConfirmPasswordEmits>() as ModalConfirmPasswordEmits;
const props = withDefaults(defineProps<ModalConfirmPasswordProps>(), ModalConfirmPasswordSetup.defaultProps);
const setup = new ModalConfirmPasswordSetup(props, emits, _modal);
// #endregion
</script>
